import { render, staticRenderFns } from "./ServiceAlgoritmLayout.vue?vue&type=template&id=c6e20dae&scoped=true"
import script from "./ServiceAlgoritmLayout.vue?vue&type=script&lang=ts"
export * from "./ServiceAlgoritmLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e20dae",
  null
  
)

export default component.exports